import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type CurrentQueryType = {
  status: number[];
  assignee: number[];
  priority: number[];
  country: [];
  report_type: number[];
  loss_value_currency: string;
  department: number[];
  report_outcome: string[];
  employee_sanction: number[];
  final_due_date: string[];
  is_anonymous: boolean;
};

type ReportingItem = {
  report_reference: string;
  country: string;
  due_date: string;
  status: string;
  report_type: string;
  priority: string;
  assignee: string;
  assigned_department: string | null;
  report_outcome: string | null;
  subject_individual: string | null;
  suspected_department: string | null;
  reporter: string;
  linked_reports: string | null;
  tags: string | null;
  followers: string | null;
  loss_value: string | null;
  loss_value_currency: string | null;
  employee_sanction: string | null;
  reportId: string;
  reportType: string;
};

type QueryType = {
  anchorEl: null;
  id: number;
  label: string;
  value: number;
  name: string;
  open: boolean;
  title: string;
  query: {
    status?: number[];
    assignee?: number[];
    priority?: number[];
    country?: string[];
    report_type?: number[];
    loss_value_currency?: string;
    department?: number[];
    report_outcome?: string[];
    employee_sanction?: string[];
    final_due_date?: string[];
    is_anonymous?: boolean;
    custom_field_titles?: string[];
    custom_case_action_field_titles?: string[];
    fields_order?: string[];
  };
};

type ReportingType = {
  items: ReportingItem[];
  page: number;
  currentReportId: number;
  queries: QueryType[];
  currentQuery: CurrentQueryType;
  loading: boolean;
  count: number;
  item: {
    label: string;
    value: number;
  } | null;
  next: number | null;
  previous: number | null;
};

const initialState: ReportingType = {
  items: [],
  queries: [],
  currentReportId: 0,
  page: 1,
  currentQuery: {
    status: [],
    assignee: [],
    priority: [],
    country: [],
    report_type: [],
    loss_value_currency: '',
    department: [],
    report_outcome: [],
    employee_sanction: [],
    final_due_date: [],
    is_anonymous: false,
  },
  item: null,
  loading: true,
  count: 0,
  next: null,
  previous: null,
};

export const reportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCurrentReportId: (state, action: PayloadAction<number>) => {
      state.currentReportId = action.payload;
    },
    setCurrentQuery: (state, action: PayloadAction<CurrentQueryType>) => {
      state.currentQuery = action.payload;
    },
    setItem: (
      state,
      action: PayloadAction<{
        label: string;
        value: number;
      }>,
    ) => {
      state.item = action.payload;
    },
    setQueries: (state, action: PayloadAction<QueryType[]>) => {
      state.queries = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setNext: (state, action: PayloadAction<number>) => {
      state.next = action.payload;
    },
    setPrevious: (state, action: PayloadAction<number>) => {
      state.previous = action.payload;
    },
    setItems: (state, action: PayloadAction<ReportingItem[]>) => {
      state.items = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLoading,
  setItems,
  setQueries,
  setItem,
  setCurrentReportId,
  setNext,
  setPrevious,
  setCurrentPage,
  setCurrentQuery,
} = reportingSlice.actions;

export default reportingSlice.reducer;
